import type { ChainNetwork, ProtoMemberRecord } from '@ducat-unit/core';
import { capitalize } from 'lodash';

import type { NetworkSettings } from '@/config/config.types';
import { GUARDIAN_NUM_FORCED } from '@/constants';

export const getOptions = (
  guards: Array<{ guardianUrl: string }> | undefined,
  network: ChainNetwork,
): { label: string; value: string }[] => {
  return (
    guards?.map((guard, index) => ({
      label: `${capitalize(network)} Guardian ${GUARDIAN_NUM_FORCED ?? getGuardianNumFromUrl(guard.guardianUrl) ?? index + 1}`,
      value: guard.guardianUrl,
      meta: guard,
    })) || []
  );
};

export const isMissingRequiredFields = ({ customGuardian, guardianUrl, guardianPublicKey }: NetworkSettings): boolean => {
  return (!customGuardian && !guardianUrl) || (customGuardian && (!guardianUrl || !guardianPublicKey));
};

export function getRandomItem<T>(list: T[]): T {
  const randomIndex = Math.floor(Math.random() * list.length);

  return list[randomIndex];
}

export function getRandomIndex<T>(list: T[]): number {
  return Math.floor(Math.random() * list.length);
}

export function getDefaultGuardMemberPubkey(guardRecords: ProtoMemberRecord[]) {
  return guardRecords[1]?.pubkey || guardRecords[0]?.pubkey;
}

export function getGuardianNumFromUrl(guardianUrl: string) {
  return guardianUrl.match(/-(\d{1})-/)?.[1];
}
